var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"8_ycm_Lzp3-8gzpuUX2Lx"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import { isShapoHost } from './lib/customDomains';

const PUBLIC_PATH_PREFIXES = [
  '/widgets',
  '/forms',
  '/surveys',
  '/wall-of-love',
  '/video',
  '/booster',
  '/tools',
];

function isPublicPath(pathname) {
  if(!pathname) {
    return false;
  }
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

const enableThirdParties = process.env.NEXT_PUBLIC_ENABLE_THIRD_PARTIES === 'true';
const enablePublicSentry = process.env.NEXT_PUBLIC_ENABLE_PUBLIC_SENTRY === 'true';

if(enableThirdParties) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.05,
    beforeSend(event) {
      if(typeof window === 'undefined') {
        return event;
      }
      const pathname = window.location ? window.location.pathname : '';
      // on a customer's own domain every page is a public page, served at "/" rather than under a public prefix
      const onCustomerDomain = window.location && !isShapoHost(window.location.hostname);
      if((onCustomerDomain || isPublicPath(pathname)) && enablePublicSentry) {
        return Math.random() <= 0.01 ? event : null;
      }
      return event;
    },
  });
}
